/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ValidationErrorResult
 */
export interface ValidationErrorResult {
    /**
     * 
     * @type {ResultStates}
     * @memberof ValidationErrorResult
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ValidationErrorResult
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationErrorResult
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationErrorResult
     */
    validationErrors: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the ValidationErrorResult interface.
 */
export function instanceOfValidationErrorResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;

    return isInstance;
}

export function ValidationErrorResultFromJSON(json: any): ValidationErrorResult {
    return ValidationErrorResultFromJSONTyped(json, false);
}

export function ValidationErrorResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationErrorResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
    };
}

export function ValidationErrorResultToJSON(value?: ValidationErrorResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
    };
}

